import { fetchWrapper } from '@/helpers/fetch-wrapper';
import { unsubscribeFCMFromServer } from '@/api/strapi/device-token';
import { router } from '@/router';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { initFCMAfterLogin, clearFCMToken, getFCMToken } from '@/firebase/firebase';
import { usePlayerStore } from '@/stores/playerStore';

const baseUrl = `${process.env.VUE_APP_SERVER_URL}`;

export const useAuthStore = defineStore('auth', () => {
    // Sử dụng ref để quản lý trạng thái
    const user = ref(JSON.parse(localStorage.getItem('user') || 'null')?.player || null);
    const returnUrl = ref(null);

    async function login(email, password) {
        try {
            const userData = await fetchWrapper.post(`${baseUrl}/api/player/login`, { email, password });
            user.value = userData.player;
            localStorage.setItem('user', JSON.stringify(userData));
            localStorage.setItem('player', JSON.stringify(userData.player));
            const playerStore = usePlayerStore();
            playerStore.setUser(userData);
            // Khởi tạo Firebase Cloud Messaging sau khi đăng nhập
            await initFCMAfterLogin();
            
            router.push(returnUrl.value || '/trang-chu');
        } catch (error) {
            console.error('Lỗi đăng nhập:', error);
            throw error;
        }
    }

    async function logout() {
        try {
            // Lấy FCM token hiện tại từ localStorage
            const fcmToken = getFCMToken();
            
            // Nếu có token, hủy đăng ký với server trước
            if (fcmToken) {
                await unsubscribeFCMFromServer(fcmToken);
                console.log('Hủy đăng ký FCM token với server thành công');
            }
            
            // Xóa FCM token khi đăng xuất
            clearFCMToken();
            
            user.value = null;
            localStorage.removeItem('user');
            localStorage.removeItem('player');
            localStorage.removeItem('followedTournaments');
            router.push('/login');
        } catch (error) {
            console.error('Lỗi khi hủy đăng ký thông báo:', error);
            // Vẫn tiếp tục đăng xuất ngay cả khi có lỗi hủy đăng ký
            user.value = null;
            localStorage.removeItem('user');
            localStorage.removeItem('player');
            router.push('/login');
        }
    }

    async function loginModal(email, password) {
        try {
            const userData = await fetchWrapper.post(`${baseUrl}/api/player/login`, { email, password });
            user.value = userData.player;
            localStorage.setItem('user', JSON.stringify(userData));
            localStorage.setItem('player', JSON.stringify(userData.player));
            
            // Khởi tạo Firebase Cloud Messaging sau khi đăng nhập
            await initFCMAfterLogin();
            
            return userData;
        } catch (error) {
            console.error('Lỗi đăng nhập modal:', error);
            throw error;
        }
    }

    return {
        user,
        returnUrl,
        login,
        loginModal,
        logout
    };
});